import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לבדידות",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה למלא.",
      "אני רק שם/ה לב לבדידות כשהיא כאן.",
      "זה מספיק לרגע."
    ],
      [
      "היום אני לא מנסה למלא.",
      "אני רק שם/ה לב לבדידות כשהיא כאן.",
      "זה מספיק לרגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הבדידות הכי מורגשת לי?",
      "מה קורה סביבי אז?",
      "איך הבדידות מרגישה בגוף שלי?"
    ],
      [
      "מתי הבדידות הכי מורגשת לי?",
      "מה קורה סביבי אז?",
      "איך הבדידות מרגישה בגוף שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב לבדידות זה כבר קשר עדין."
    ],
      [
      "לשים לב לבדידות זה כבר קשר עדין."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילים \"אני כאן\".",
      "נשימה אחת עם המילים \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה חסר לי שם",
    opening: localizedGenderNode(
      [
      "היום אני שואל/ת מה חסר לי בתוך האנשים.",
      "בלי אשמה.",
      "רק לראות."
    ],
      [
      "היום אני שואל/ת מה חסר לי בתוך האנשים.",
      "בלי אשמה.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה חסר לי בקשר עם האנשים סביבי?",
      "מה הייתי רוצה שיראו בי?",
      "מה קשה לי לבקש?"
    ],
      [
      "מה חסר לי בקשר עם האנשים סביבי?",
      "מה הייתי רוצה שיראו בי?",
      "מה קשה לי לבקש?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לפעמים חסר קטן מסביר הרבה."
    ],
      [
      "לפעמים חסר קטן מסביר הרבה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על החסר.",
      "לכתוב מילה אחת על החסר."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הרגע שבו אני מתרחק/ת",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע ההתרחקות.",
      "בלי לשפוט.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב לרגע ההתרחקות.",
      "בלי לשפוט.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני נסגר/ת ליד אנשים?",
      "מה מפעיל את זה בי?",
      "מה אני מנסה להגן עליו?"
    ],
      [
      "מתי אני נסגר/ת ליד אנשים?",
      "מה מפעיל את זה בי?",
      "מה אני מנסה להגן עליו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם סגירה היא ניסיון לשמור."
    ],
      [
      "גם סגירה היא ניסיון לשמור."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"אני מבין/ה\".",
      "לומר לעצמי \"אני מבין/ה\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "נוכחות בלי מסכה",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך זה להיות רגע בלי מסכה.",
      "לא הרבה.",
      "רק קצת."
    ],
      [
      "היום אני בודק/ת איך זה להיות רגע בלי מסכה.",
      "לא הרבה.",
      "רק קצת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הפנים."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הפנים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מסתיר/ה בדרך כלל?",
      "מה אני מפחד/ת שיראו?",
      "איפה אפשר לשחרר 1%?"
    ],
      [
      "מה אני מסתיר/ה בדרך כלל?",
      "מה אני מפחד/ת שיראו?",
      "איפה אפשר לשחרר 1%?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רגע קטן של אמת מחמם את הלב."
    ],
      [
      "רגע קטן של אמת מחמם את הלב."
    ]
    ),
    action: localizedGenderNode(
      "משפט אמת אחד לעצמי.",
      "משפט אמת אחד לעצמי."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הדפוס שמחזיק אותי לבד",
    opening: localizedGenderNode(
      [
      "היום אני רואה דפוס קטן שמרחיק אותי.",
      "בלי אשמה.",
      "רק אור."
    ],
      [
      "היום אני רואה דפוס קטן שמרחיק אותי.",
      "בלי אשמה.",
      "רק אור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הבטן."
    ],
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הבטן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה דפוס חוזר כשאני עם אנשים?",
      "איך הוא מגן עליי?",
      "מה המחיר שלו בשבילי?"
    ],
      [
      "איזה דפוס חוזר כשאני עם אנשים?",
      "איך הוא מגן עליי?",
      "מה המחיר שלו בשבילי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "דפוס מגן לפעמים גם כואב."
    ],
      [
      "דפוס מגן לפעמים גם כואב."
    ]
    ),
    action: localizedGenderNode(
      "לזהות דפוס אחד בשם.",
      "לזהות דפוס אחד בשם."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "הצורך שמתחת",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת את הצורך שמתחת לבדידות.",
      "לא כיוון.",
      "רק צורך."
    ],
      [
      "היום אני מחפש/ת את הצורך שמתחת לבדידות.",
      "לא כיוון.",
      "רק צורך."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני באמת בוחר/ת/ה כאן?",
      "מה הייתי רוצה לקבל?",
      "מה אני יכול/ה לתת לעצמי עכשיו?"
    ],
      [
      "מה אני באמת בוחר/ת/ה כאן?",
      "מה הייתי רוצה לקבל?",
      "מה אני יכול/ה לתת לעצמי עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צורך אחד ברור מרכך את הלב."
    ],
      [
      "צורך אחד ברור מרכך את הלב."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב צורך אחד במילה.",
      "לכתוב צורך אחד במילה."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "רגע חיבור קטן",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת רגע חיבור קטן.",
      "לא גדול.",
      "מספיק קטן."
    ],
      [
      "היום אני מחפש/ת רגע חיבור קטן.",
      "לא גדול.",
      "מספיק קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הנשימה."
    ],
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הנשימה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי היה לי חיבור קטן לאחרונה?",
      "מה אפשר לי להרגיש אותו?",
      "מה צעד קטן שיכול להזמין עוד?"
    ],
      [
      "מתי היה לי חיבור קטן לאחרונה?",
      "מה אפשר לי להרגיש אותו?",
      "מה צעד קטן שיכול להזמין עוד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם חיבור קטן משנה את היום."
    ],
      [
      "גם חיבור קטן משנה את היום."
    ]
    ),
    action: localizedGenderNode(
      "לזכור רגע כזה.",
      "לזכור רגע כזה."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "גבול שמגן על החיבור",
    opening: localizedGenderNode(
      [
      "היום אני רואה גבול שמגן עליי בתוך אנשים.",
      "בלי להתרחק.",
      "רק לשמור."
    ],
      [
      "היום אני רואה גבול שמגן עליי בתוך אנשים.",
      "בלי להתרחק.",
      "רק לשמור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני נותן/ת יותר מדי בקשרים?",
      "איזה גבול קטן יכול לעזור?",
      "איך אני אומר/ת אותו לעצמי?"
    ],
      [
      "איפה אני נותן/ת יותר מדי בקשרים?",
      "איזה גבול קטן יכול לעזור?",
      "איך אני אומר/ת אותו לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול קטן שומר על נוכחות."
    ],
      [
      "גבול קטן שומר על נוכחות."
    ]
    ),
    action: localizedGenderNode(
      "משפט גבול אחד לעצמי.",
      "משפט גבול אחד לעצמי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "להישאר עוד רגע",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להישאר עוד רגע.",
      "לא להיעלם מהר.",
      "רק רגע."
    ],
      [
      "היום אני מתרגל/ת להישאר עוד רגע.",
      "לא להיעלם מהר.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני בורח/ת מהר?",
      "מה מפחיד אותי אם אני נשאר/ת?",
      "מה יהיה אם אשאר עוד 10 שניות?"
    ],
      [
      "מתי אני בורח/ת מהר?",
      "מה מפחיד אותי אם אני נשאר/ת?",
      "מה יהיה אם אשאר עוד 10 שניות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עוד רגע אחד הוא לפעמים שינוי."
    ],
      [
      "עוד רגע אחד הוא לפעמים שינוי."
    ]
    ),
    action: localizedGenderNode(
      "לעצור 10 שניות לפני שאני נעלם/ת.",
      "לעצור 10 שניות לפני שאני נעלם/ת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה אחת ברורה",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה אחת מול עצמי.",
      "לא לדרוש.",
      "רק להכיר."
    ],
      [
      "היום אני מנסח/ת בקשה אחת מול עצמי.",
      "לא לדרוש.",
      "רק להכיר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה בקשה אחת שהייתי רוצה להביא?",
      "איך אפשר לומר אותה ברוך?",
      "מה צעד קטן שאני יכול/ה לעשות?"
    ],
      [
      "מה בקשה אחת שהייתי רוצה להביא?",
      "איך אפשר לומר אותה ברוך?",
      "מה צעד קטן שאני יכול/ה לעשות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לפתוח דלת לחיבור."
    ],
      [
      "בקשה אחת יכולה לפתוח דלת לחיבור."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "מבט אחד שמחזיק",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת מבט אחד שמחזיק אותי.",
      "גם מבט פנימי.",
      "מספיק."
    ],
      [
      "היום אני מחפש/ת מבט אחד שמחזיק אותי.",
      "גם מבט פנימי.",
      "מספיק."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את העיניים."
    ],
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את העיניים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מי או מה נותן לי תחושה של ראייה?",
      "איך זה מרגיש כשמישהו באמת רואה אותי?",
      "איך אני יכול/ה לתת את זה לעצמי?"
    ],
      [
      "מי או מה נותן לי תחושה של ראייה?",
      "איך זה מרגיש כשמישהו באמת רואה אותי?",
      "איך אני יכול/ה לתת את זה לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מבט עדין יכול לפתוח מקום."
    ],
      [
      "מבט עדין יכול לפתוח מקום."
    ]
    ),
    action: localizedGenderNode(
      "להביט בעצמי רגע במראה בעדינות.",
      "להביט בעצמי רגע במראה בעדינות."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "קול שקט בתוכי",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לקול השקט שבתוכי.",
      "גם אם הוא קטן.",
      "הוא שם."
    ],
      [
      "היום אני מקשיב/ה לקול השקט שבתוכי.",
      "גם אם הוא קטן.",
      "הוא שם."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני נותן/ת לו מקום."
    ],
      [
      "אני נושם/ת לאט.",
      "אני נותן/ת לו מקום."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הקול השקט אומר לי עכשיו?",
      "מה הוא מבקש ממני?",
      "איך מרגיש להקשיב לו?"
    ],
      [
      "מה הקול השקט אומר לי עכשיו?",
      "מה הוא מבקש ממני?",
      "איך מרגיש להקשיב לו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול שקט יכול להחזיר אותי לעצמי."
    ],
      [
      "קול שקט יכול להחזיר אותי לעצמי."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד מהקול השקט.",
      "משפט אחד מהקול השקט."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "בחירה קטנה בקשר",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן לקראת חיבור.",
      "בלי דרמה.",
      "צעד קטן."
    ],
      [
      "היום אני בוחר/ת צעד קטן לקראת חיבור.",
      "בלי דרמה.",
      "צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה מפחיד אותי בצעד הזה?",
      "איך זה ישמור עליי?"
    ],
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה מפחיד אותי בצעד הזה?",
      "איך זה ישמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן יכול לשנות קצב."
    ],
      [
      "צעד קטן יכול לשנות קצב."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד אחד קטן ולזכור אותו.",
      "לבחור צעד אחד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לחיבור.",
      "כשאני נסגר/ת.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לחיבור.",
      "כשאני נסגר/ת.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הבדידות הזו?",
      "מה הסימן הראשון שהיא חוזרת?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ],
      [
      "מה למדתי על הבדידות הזו?",
      "מה הסימן הראשון שהיא חוזרת?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה להרגיש לבד ולהישאר עם עצמי."
    ],
      [
      "אני יכול/ה להרגיש לבד ולהישאר עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const lonelinessEvenWhenThereArePeopleAroundBlueprintHe = buildNormalizedPilotBlueprint({
  id: "loneliness_even_when_there_are_people_around_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "loneliness_even_when_there_are_people_around",
  category: "loneliness_belonging",
  journeyName: {
    he: "בדידות גם כשיש אנשים מסביב",
    en: "Loneliness even when there are people around",
    es: "Soledad incluso cuando hay gente alrededor",
  },
  days,
});

export default lonelinessEvenWhenThereArePeopleAroundBlueprintHe;
